import React, { useState } from 'react';
import { mdiRestart, mdiCheckCircle, mdiAlertCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { IMSImportantActivities } from '@/lib/msImportantActivities';

interface IProps {
  list: IMSImportantActivities[];
  updateList: (list: IMSImportantActivities[]) => void;
  isMsImportantActivitiesListValid: boolean;
  touched: boolean;
}

const RankPreference = ({
  list,
  updateList,
  isMsImportantActivitiesListValid,
  touched,
}: IProps): JSX.Element => {
  const [clickCount, setClickCount] = useState<number>(0);
  const reset = () => {
    const rearrangedList = list?.map(item => ({
      ...item,
      rank: undefined,
    }));

    setClickCount(0);
    updateList(rearrangedList);
  };

  const handleChange = (e: React.MouseEvent<HTMLElement>, index: number) => {
    e.preventDefault();
    let count = clickCount;

    if (count >= list.length) {
      count = 1;
    } else {
      count += 1;
    }

    setClickCount(count);

    const itemWithSameRank = list?.findIndex(v => v.rank === count);

    if (list && itemWithSameRank) {
      const tempList = list;
      tempList[itemWithSameRank] = {
        ...tempList[itemWithSameRank],
        rank: tempList[index].rank,
      };
      tempList[index] = {
        ...tempList[index],
        rank: count,
      };
      updateList([...tempList]);
    }
  };

  return (
    <>
      <div className="is-flex is-justify-content-space-between">
        <label
          htmlFor="onboarding-dmtRecommendationRate"
          className="label mb-0">
          Rank which is most important to you in managing your MS?
        </label>
      </div>
      <div className="help mb-2 mt-0">
        Click or tap each option in order of importance. The first being most
        important. Click the reset button to start again.
      </div>
      <div className="panel mt-0 ml-0 mb-2">
        {list.map((item: IMSImportantActivities, index: number) => (
          <div key={item.id} className="panel-block p-0">
            {item.rank ? (
              <div
                className={`px-3 py-2 is-flex is-justify-content-space-between is-align-items-center rank-preferences-item${
                  item.rank ? ` rank-preferences-item-${item.rank}` : ``
                }`}>
                <div className="list-item-title">{item.name}</div>
                <span className="rank-preferences-number">{item.rank}</span>
              </div>
            ) : (
              <a
                href="#"
                key={item.id}
                className={`px-3 py-2 is-flex is-justify-content-space-between is-align-items-center rank-preferences-item${
                  item.rank ? ` rank-preferences-item-${item.rank}` : ``
                }`}
                onClick={e => handleChange(e, index)}>
                <div className="list-item-title">{item.name}</div>
                <span className="rank-preferences-number">{item.rank}</span>
              </a>
            )}
          </div>
        ))}
      </div>
      <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center">
        <button type="button" onClick={reset} className="button is-small">
          <span className="icon">
            <Icon path={mdiRestart} size={0.75} />
          </span>
          <span>Reset</span>
        </button>
        <div
          className={`tag is-flex is-flex-direction-row is-align-items-center px-1 ${
            clickCount < list.length
              ? `has-background-warning`
              : `has-background-info`
          }`}>
          <span className="icon mr-1">
            {clickCount < list.length ? (
              <Icon path={mdiAlertCircle} size={0.75} />
            ) : (
              <Icon path={mdiCheckCircle} size={0.75} />
            )}
          </span>
          <span>
            {clickCount} of {list.length} selected
          </span>
        </div>
      </div>
      {!isMsImportantActivitiesListValid && touched ? (
        <div className="help is-danger">
          Please rank which is most important to you in managing your MS
        </div>
      ) : null}
    </>
  );
};

export default RankPreference;
